<template>
    <v-select
        @input="input"
        :options="options"
        :value="value"
        :multiple="multiple"
        :name="name"
        :placeholder="placeholder"
        class="subject-dropdown"
    ></v-select>
</template>

<script>
export default {
    name: 'XSelect',

    props: {
        value: {},

        name: {},

        placeholder: {},

        options: {
            type: Array
        },

        multiple: {}
    },

    methods: {
        input(val) {
            this.$emit('input', val)
        }
    }
}
</script>
<style>
.subject-dropdown > .vs__dropdown-toggle .vs__selected {
    background-color: transparent;
    color: #495057;
    border: none;
    box-shadow: none;
}

body.theme-dark-mode .subject-dropdown > .vs__dropdown-toggle .vs__selected {
    color: white;
}
</style>
